import styled from "styled-components";

export const TileContainer = styled.ul`
  column-count: 1;

  @media (min-width: ${({ theme }) => theme.breakpoints.sm}) {
    column-count: 2;
  }
  @media (min-width: ${({ theme }) => theme.breakpoints.md}) {
    column-count: 3;
  }
`;

export const TileListItem = styled.li`
  margin-bottom: ${({ theme }) => theme.space.sm};
  display: inline-block;
  width: 100%;
`;
